$('.event-teacher-info-show-js').click(function(e) {
  e.preventDefault();
  let $cont = $(this).closest('.event-info').find('.event-teacher-info');
  openModal($cont.html());
});

$('.event-order-js').click(function() {
  let eventId = $(this).data('id');
  $.get(
    '/wp-admin/admin-ajax.php?action=get_event_order_form&event_id=' + eventId,
    data => {
      if (!data.content) {
        let event = data.event;
        openFreeEventModal(event);
      }
      else {
        openEventPayment(data.event, data.content);
      }
    });
});

function openEventPayment(event, content) {
  let modal = openModal(content, {
    cssClass: ['record-form-modal'],
  });
  let form = modal.modal.querySelector('form');
  let telInput = form.elements.client_phone;
  let emailInput = form.elements.client_email;
  let nameInput = form.elements.client_name;
  let couponInput = modal.modalBox.querySelector('[name="coupon"]');

  if (window.recordFormData) {
    telInput.value = window.recordFormData.client_phone || '';
    emailInput.value = window.recordFormData.client_email || '';
    nameInput.value = window.recordFormData.client_name || '';
  }

  form.validate = function() {
    return validateRecordForm(form, emailInput, telInput);
  };

  hotValidationInit(form);

  // tel mask
  initTelMask(form.elements.client_phone);
  initCouponInput(couponInput, 'event');

  //bind form submit
  form.addEventListener('submit', function(e) {
    if(this.disabledTmp){
      e.preventDefault();
      return;
    }

    this.querySelectorAll('input').forEach(input => {
      input.changed = true;
    });
    e.preventDefault();

    if (!this.validate()) {
      return;
    }

    reachMetricGoal('EVENT_ORDER');
    setTimeout(() => {
      this.submit();
    }, 0);
  });
}

function openFreeEventModal(event) {
  let subtitle = `${event.title} <br> ${event.dateLabel}`;
  openRecordFormModal({
    title: 'Запись на мероприятие',
    subtitle,
    submitCallback({e, form}) {
      e.preventDefault();

      form.querySelectorAll('input').forEach(input => {
        input.changed = true;
      });

      if (!form.validate()) {
        return;
      }

      let data = $(form).serialize() +
        '&event_id=' + event.id +
        '&title=' + 'Новая запись на мероприятие. ' + subtitle +
        '&page=' + document.location.href;

      $.post('/wp-json/api/v1/events/entry', data, function() {
        if (typeof form.submitCallback === 'function') {
          form.submitCallback();
        }

        reachMetricGoal('EVENT_ORDER');
        openModal('Спасибо за заявку. В ближайшее время мы с вами свяжемся');
      });
    },
  });
}